import { getStorageCurrentProperties, getStoragePersonalDetails, getStorageCurrentShare, getStorageToken } from "common/utils/localStorage";
import { Investment } from "./investment/types";
import { Property } from "./property/types";
import { User } from "./user/types";

export type ID = string;

export interface StoreState {
  properties: Property[];
  currentUser: User;
  token: string;
  currentShare: Investment;
}

export const initialState = {
  properties: getStorageCurrentProperties(),
  currentUser: getStoragePersonalDetails(),
  token: getStorageToken(),
  currentShare: getStorageCurrentShare(),
};
